import { 
  statusRegFormStart,
  statusRegFormSuccess,
  statusRegFormFailure 
} from "./regFormSlice";
import { get, put } from "../../requestMethods"
import { Dispatch } from "react";

export const getRegFormsApi = (doctorId: any) => async (dispatch: Dispatch<any>) => {
  try {
    dispatch(statusRegFormStart())
    let response
    if(doctorId) {
      response = await get(`regform?doctor=${doctorId}`);
    } else {
      response = await get(`regform`);
    }
    const resData = response.data.success
    if(resData) {
      dispatch(statusRegFormSuccess(resData))
      return true
    }
  } catch (err: any) {
    const errData = err.response.data
    if(errData && err.response.status === 300) {
      const formErrors = errData.formErrors ? errData.formErrors : [errData] 
      dispatch(statusRegFormFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusRegFormFailure(errData))
      return [errData]
    }
  }
}

export const EditRegFormApi = (regFormId: string, doctorId: string = "", data: any) => async (dispatch: Dispatch<any>) => {
  try {
    dispatch(statusRegFormStart())
    const response = await put(`regform/${regFormId}?doctor=${doctorId}`, data);
    const resData = response.data.success
    if(resData) {
      dispatch(statusRegFormSuccess(resData))
      return true
    }
  } catch (err: any) {
    const errData = err.response.data
    if(errData && err.response.status === 300) {
      const formErrors = errData.formErrors ? errData.formErrors : [errData] 
      dispatch(statusRegFormFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusRegFormFailure(errData))
      return [errData]
    }
  }
}

export const clearRegFormApi = async (dispatch: Dispatch<any>) => {
  dispatch(statusRegFormSuccess([]))
}
